var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-8",staticStyle:{"height":"250px"}},[_c('Pie',{attrs:{"options":_vm.chartOptions,"data":_vm.display}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }